module.exports = __webpack_public_path__ + "img/2017博览会.aaf6d31d.jpg";